var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProjectBrief(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 2.39844V5.99844C15.0001 6.66118 15.5373 7.19844 16.2001 7.19844H19.8001M8.40008 7.19844H10.8001M8.40008 10.7984H15.6001M8.40008 14.3984H15.6001M18.0001 4.19844C17.466 3.72058 16.9118 3.15382 16.5619 2.78572C16.3291 2.54077 16.0074 2.39844 15.6695 2.39844H6.5998C5.27432 2.39844 4.19981 3.47295 4.1998 4.79842L4.19971 19.1984C4.1997 20.5239 5.27421 21.5984 6.5997 21.5984L17.3997 21.5984C18.7252 21.5984 19.7997 20.524 19.7998 19.1985L19.8001 6.47627C19.8001 6.16943 19.683 5.87447 19.4701 5.65357C19.0763 5.24508 18.4187 4.57295 18.0001 4.19844Z",
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectBrief);
export default __webpack_public_path__ + "static/media/project-brief.857e560740926d0b939fd88911acac93.svg";
export { ForwardRef as ReactComponent };